var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFLongText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E6F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16172_5605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.75C12.3353 15.75 12 15.4148 12 15V3.75C12 3.33525 12.3353 3 12.75 3C13.1647 3 13.5 3.33525 13.5 3.75V15C13.5 15.4148 13.1647 15.75 12.75 15.75Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.75C10.0853 15.75 9.75 15.4148 9.75 15V3.75C9.75 3.33525 10.0853 3 10.5 3C10.9147 3 11.25 3.33525 11.25 3.75V15C11.25 15.4148 10.9147 15.75 10.5 15.75Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75H7.875C6.01425 9.75 4.5 8.23575 4.5 6.375C4.5 4.51425 6.01425 3 7.875 3H14.25C14.6648 3 15 3.33525 15 3.75C15 4.16475 14.6648 4.5 14.25 4.5H7.875C6.84075 4.5 6 5.34075 6 6.375C6 7.40925 6.84075 8.25 7.875 8.25H10.5C10.9148 8.25 11.25 8.58525 11.25 9C11.25 9.41475 10.9148 9.75 10.5 9.75Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.75H9C8.58525 15.75 8.25 15.4147 8.25 15C8.25 14.5853 8.58525 14.25 9 14.25H14.25C14.6648 14.25 15 14.5853 15 15C15 15.4147 14.6648 15.75 14.25 15.75Z",
    fill: "#038A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8207 17.5875L18.1957 15.15C18.0892 15.0518 17.952 15 17.8125 15C17.736 15 17.6603 15.0158 17.5875 15.0465C17.3828 15.1365 17.25 15.339 17.25 15.5625V17.25H3.75C3.33525 17.25 3 17.5852 3 18C3 18.4147 3.33525 18.75 3.75 18.75H17.25V20.4375C17.25 20.661 17.3828 20.8635 17.5875 20.9535C17.7923 21.042 18.0315 21.0022 18.1957 20.85L20.8207 18.4125C20.9347 18.306 21 18.1567 21 18C21 17.8432 20.9347 17.6948 20.8207 17.5875Z",
    fill: "#038A4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16172_5605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFLongText);
export default __webpack_public_path__ + "static/media/fLongText.23feb9d5f3c5cf1b171be8ce05073d77.svg";
export { ForwardRef as ReactComponent };